import AppHeader from "../../layout/AppHeader";
import CockpitPrePostAdmin from '../../xpost/views/dashboard/CockpitPrepostAdmin.vue';
import CockpitPrePostUser from '../../xpost/views/dashboard/CockpitPrepostUser.vue';
import ExternalPostList from '../../xpost/views/dashboard/prepost/components/ExternalPostList';
import PostList from '../../xpost/views/dashboard/prepost/PostList.vue';
import ImportMain from '../../xpost/views/services/import/ImportMain.vue';
import PlpExternalRegister from '../../xpost/views/services/plp.external/PlpExternalRegister';
import PrePostAdd from '../../xpost/views/services/pre.post/PrePostAdd.vue';
import PrepostPrint from '../../xpost/views/services/pre.post/PrepostPrint.vue';
import HistorySgp from '../../xpost/views/services/sgp/HistorySgp.vue';
import PostObjectsSro from '../../xpost/views/dashboard/prepost/PostObjectsSro.vue';
import CalculatePage from '../../maisenvios/page/services/CalculatePage';
import CalculateResultPage from '../../maisenvios/page/services/CalculateResultPage';
import PostPage from '../../maisenvios/page/services/PostPage';
import Motoboy from "../../xpost/views/services/motoboy/Motoboy.vue";
import MotoboyAdd from "../../xpost/views/services/motoboy/MotoboyAdd.vue";

const PrePostRoutes = [
  {
    path: "/servicos/prepostagem",
    name: "pre.post",
    meta: { preset: "pre" },
    components: {
      header: AppHeader,
      default: PostList,
    }
  },
  {
    path: "/servicos/postsro",
    name: "PostObjectsSro",
    components: {
      header: AppHeader,
      default: PostObjectsSro,
    }
  },
  {
    path: "/servicos/postagem",
    name: "post",
    meta: { preset: "post" },
    components: {
      header: AppHeader,
      default: PostList,
    }
  },
  {
    path: "/servicos/importar",
    name: "pre.post.import",
    components: {
      header: AppHeader,
      default: ImportMain,
    }
  },
  {
    path: "/servicos/prepostagem/adicionar",
    name: "prepost.add",
    components: {
      header: AppHeader,
      default: PrePostAdd,
    }
  },
  {
    path: "/servicos/plp/terceiros",
    name: "plp.external",
    components: {
      header: AppHeader,
      default: ExternalPostList,
    }
  },
  {
    path: "/servicos/plp/terceiros",
    name: "plp.external.add",
    components: {
      header: AppHeader,
      default: PlpExternalRegister,
    }
  },
  {
    path: "/cockpit/prepostagem/usuario",
    name: "cockpit.user.pre.post",
    components: {
      header: AppHeader,
      default: CockpitPrePostUser,
    }
  },
  {
    path: "/servicos/motoboy",
    name: "motoboy",
    components: {
      header: AppHeader,
      default: Motoboy,
    }
  },
  {
    path: "/servicos/motoboy/adicionar",
    name: "motoboy.add",
    components: {
      header: AppHeader,
      default: MotoboyAdd,
    }
  },
  {
    path: "/cockpit/prepostagem/admin",
    name: "cockpit.admin.pre.post",
    components: {
      header: AppHeader,
      default: CockpitPrePostAdmin,
    }
  },
  {
    path: "/cockpit/prepostagem/:id/print",
    name: "cockpit.admin.prepost.print",
    component: PrepostPrint
  },
  {
    path: "/servicos/historico",
    name: "history.sgp",
    component: HistorySgp
  },
  {
    path: "/servicos/calculadora",
    name: "calculadora.frete",
    component: CalculatePage
  },
  {
    path: "/servicos/calculadora/resultado",
    name: "calculadora.frete.resultado",
    component: CalculateResultPage
  },
  {
    path: "/postagem",
    name: "post.page.add",
    component: PostPage
  },
  
]

export default PrePostRoutes;